export type ConversationFilter = "all" | "unread";

/** Every chat query lives under ["chat"], so logout can drop them in one call. */
export const chatKeys = {
  all: ["chat"] as const,
  lists: () => ["chat", "conversations"] as const,
  list: (filter: ConversationFilter) => ["chat", "conversations", filter] as const,
  conversation: (id: string) => ["chat", "conversation", id] as const,
  messagesRoot: () => ["chat", "messages"] as const,
  messages: (conversationId: string) => ["chat", "messages", conversationId] as const,
  unread: () => ["chat", "unread"] as const,
  attachmentUrls: (attachmentId: string) => ["chat", "attachment-urls", attachmentId] as const,
};
